import React from 'react';
import MenuItem, { MenuItemProps } from '@material-ui/core/MenuItem';
import { ISuggestion, ISuggestionSourceType } from '../../services/types';
import { Box, Chip, Typography } from '@material-ui/core';

type IProps = {
  highlightedIndex: number | null;
  index: number;
  itemProps: MenuItemProps<'div', { button?: never }>;
  selectedItem: ISuggestion | null;
  suggestion: ISuggestion;
  innerHTML?: string;
  onClick?: (suggestion: ISuggestion) => void;
};

const SuggestionItem = (suggestionProps: IProps): JSX.Element => {
  const { suggestion, index, itemProps, highlightedIndex, selectedItem, innerHTML, onClick } = suggestionProps;

  const isHighlighted = highlightedIndex === index;
  const isSelected = selectedItem && selectedItem.text.indexOf(suggestion.text) > -1;

  const { type: sourceType, id: sourceId } = suggestion._source;

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();

    if (onClick) {
      onClick(suggestion);
    }
  };

  const getChipColors = (type: ISuggestionSourceType) => {
    switch (type) {
      case 'penname':
        return {
          backgroundColor: '#697689',
          color: '#eee',
        };

      case 'story':
        return {
          backgroundColor: '#ff008a',
          color: '#eee',
        };
      case 'season':
        return {
          backgroundColor: '#37d67a',
          color: '#000',
        };
      case 'user':
        return {
          backgroundColor: '#2ccce4',
          color: '#eee',
        };
      case 'theme':
        return {
          backgroundColor: '#ba68c8',
          color: '#eee',
        };
      default:
        break;
    }
  };

  return (
    <MenuItem
      {...itemProps}
      key={`${sourceType}-${sourceId}`}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      onClick={handleClick}
    >
      <Box display="flex" alignItems="center">
        <Chip
          size="small"
          label={sourceType}
          style={{
            textTransform: 'capitalize',
            height: '14px',
            borderRadius: '7px',
            marginRight: '7px',
            ...getChipColors(sourceType),
          }}
        />
        <Typography>
          <span
            dangerouslySetInnerHTML={{
              __html: innerHTML || suggestion.highlight,
            }}
          />
        </Typography>
      </Box>
      <Typography style={{ fontSize: '11px', color: '#666' }}>{`ID: ${sourceId}`}</Typography>
    </MenuItem>
  );
};

export default SuggestionItem;
